export function validateConfig(config) {
    return config != null && !Array.isArray(config) && typeof config === 'object';
}
